import { Box, styled } from '@mui/material';
import { colors } from '@watter/shared-components';

export const EditWrapper = styled(Box)(({ theme }) => ({
    '& .listBox': {
        padding: theme.spacing(3),
        background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
        borderRadius: theme.spacing(1),
        '& .MuiTypography-subtitle1': {
            color: theme.palette.mode === 'dark' ? colors?.info : colors?.lightHead,
            fontFamily: 'good_sansregular',
        },
        '& .MuiFormControl-root.MuiTextField-root': {
            marginBottom: 0,
            '& .MuiInputBase-root': {
                paddingLeft: 0,
                paddingBottom: 0,
                '& .MuiInputBase-input': {
                    padding: theme.spacing(1.5, 0),
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: 0,
                    borderWidth: '0px 0px 1px 0px',
                    borderColor: theme.palette.mode === 'dark' ? colors?.white : colors?.lightGray,
                },
            },
        },
        '& .MuiFormControl-root': {
            '& .MuiFormLabel-root': {
                left: theme.spacing(-2),
                top: theme.spacing(0.25),
                '&.Mui-focused': {
                    color: theme.palette.mode === 'dark' ? colors?.info : colors?.lightHead,
                },
            },
        },
        '& .cstMobileNumber': {
            '& .MuiSelect-select[role="combobox"]': {
                padding: theme.spacing(1.5, 0),
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0px 0px 1px 0px',
                borderRadius: '0px',
                borderColor: theme.palette.mode === 'dark' ? colors?.white : colors?.lightGray,
            },
        },
        '& .cstNoBorder': {
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
    },
    '& .cstActionBtns': {
        '& .MuiButtonBase-root': {
            padding: theme.spacing(2, 0),
            minWidth: theme.spacing(25),
            background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
        },
    },
}));
export const CustomTabs = styled(Box)(({ theme }) => ({
    '& .MuiTabs-root': {
        minHeight: theme.spacing(5.5),
        borderRadius: theme.spacing(6.25),
        background: theme.palette.mode === 'dark' ? colors?.lightHead : colors?.whiteSmoke,
        '& .MuiTabs-scroller': {
            '& .MuiTabs-flexContainer': {
                padding: theme.spacing(0.375),
                borderBottom: 'none',
                '& .MuiTab-root': {
                    minHeight: theme.spacing(5),
                    maxHeight: theme.spacing(5),
                    textAlign: 'center',
                    minWidth: theme.spacing(26),
                    padding: 0,
                    '&.Mui-selected': {
                        borderRadius: theme.spacing(6.25),
                        border: 'none',
                        fontWeight: 600,
                        background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.lightGray,
                        color: theme.palette.mode === 'dark' ? colors?.white : colors?.blackColor,
                    },
                },
            },
            '& .MuiTabs-indicator': {
                display: 'none',
            },
        },
    },
}));
export const AddHeaterWrapper = styled(Box)(({ theme }) => ({
    '& .MuiDialog-paper': {
        zIndex: 0,
    },
    '&.changePassword': {
        '& .MuiDialog-paper': {
            padding: theme.spacing(2),

            alignItems: 'center',
        },
    },
    '& .cstBtnWrapper': {
        '& .MuiBox-root': {
            position: 'relative',
            padding: theme.spacing(0.2),
            margin: '10px 10px',

            '& .cstBtn': {
                width: '200px',

                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
            },
            '& .cstBtn2': {
                width: '200px',
                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
                border: '1px solid var(--Color-tokens-Strokes-Neutral-Dark, #47474B)',
            },
            '&:active': {
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                borderRadius: theme.spacing(4),
            },

            '&:active::after': {
                content: "''",
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: -1,
                inset: 0,
                borderRadius: theme.spacing(4),
            },
        },
    },
}));
